import QzTrayClientSignerService from "../../services/qztray/QzTrayClientSignerService";

/**
 * ✍️ Hook para firmar solicitudes QZ Tray usando backend
 */
export const useQzTrayClientSigner = () => {

  const sign = async (toSign: string) => {
    const response = await QzTrayClientSignerService.signRaw(toSign);
    console.log(response);
    const { statusCode, data } = response;
    if (statusCode !== 200) {
      console.error("❌ Error en firma QZ Tray:", response);
      throw new Error(response.message || "Error al firmar");
    }
    if (!data?.signature || typeof data.signature !== "string") {
      throw new Error("El backend no devolvió una firma QZ Tray válida");
    }
    return data.signature;
  };

  return { sign };
};
